<template>
  <div class="vx-row">
    <div class="vx-col">
      <vs-button
        color ="warning"
        type="border"
        @click="createTopicTrial"
        class="text-size"
      >
        {{$t('trial.addTopic')}}
      </vs-button>
    </div>
    <div class="vx-col">
      <vs-button
        color ="primary"
        @click="manageTopic"
        class="text-size"
      >
        {{$t('trial.manage')}}
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  data() {
    return {
      userList: [
        {label:'Bán lẻ & thương mại', value: 0, email : 'banlethuongmai@gmail.com', phoneNumber : '0986565656'},
        {label: 'Bảo hiểm', value: 1, email : 'baohiem@gmail.com', phoneNumber : '0972656565'},
        {label: 'Bất động sản', value: 3, email : 'batdongsan@gmail.com', phoneNumber : '0932456789'},
        {label: 'CNTT & Viễn thông', value: 4, email : 'cnttvienthong@gmail.com', phoneNumber : '0947749794'},
        {label: 'Dịch vụ công & nhà nước', value: 5, email : 'dichvucongvanhanuoc@gmail.com', phoneNumber : '0984489849'},
        {label: 'Dịch vụ vận tải', value: 6, email : 'dichvuvantai@gmail.com', phoneNumber : '0986689869'},
        {label: 'Dược và Y tế', value: 7, email : 'duocvayte@gmail.com', phoneNumber : '0985589859'},
        {label: 'Fintech', value: 8, email : 'fintech@gmail.com', phoneNumber : '0983389839'},
        {label: 'Giải trí', value: 9, email : 'giaitri@gmail.com', phoneNumber : '0972279729'},
        {label: 'Giáo dục', value: 10, email : 'giaoduc@gmail.com', phoneNumber : '0984489848'},
        {label: 'Giao nhận vận tải', value: 11, email : 'giaothongvantai@gmail.com', phoneNumber : '0985657894'},
        {label: 'Khách sạn và nhà nghỉ', value: 12, email : 'khachsanvanhanghi@gmail.com', phoneNumber : '0941149419'},
        {label: 'Làm đẹp, Mỹ phẩm & Sức khoẻ', value: 13, email : 'lamdepmyphamvasuckhoe@gmail.com', phoneNumber : '0941148481'},
        {label: 'Luật/Pháp lý', value: 14, email : 'luatphaply@gmail.com', phoneNumber : '0941147471'},
        {label: 'Năng lượng', value: 15,email : 'nangluong@gmail.com', phoneNumber : '0941146461'},
        {label: 'Nông nghiệp', value: 16,email : 'nongnghiep@gmail.com', phoneNumber : '0941145451'},
        {label: 'Quảng cáo/Truyền thông', value: 17,email : 'quangcaotruyenthong@gmail.com', phoneNumber : '0941144441'},
        {label: 'Tài chính/Ngân hàng', value: 18,email : 'taichinhnganhang@gmail.com', phoneNumber : '0941143431'},
        {label: 'Thực phẩm & Đồ uống', value: 19,email : 'thucphamdouong@gmail.com', phoneNumber : '0971148481'},
        {label: 'Thương mại điện tử', value: 20,email : 'thuongmaidientu@gmail.com', phoneNumber : '0975456789'},
        {label: 'Tiêu dùng nhanh', value: 21,email : 'tieudungnhanh@gmail.com', phoneNumber : '0974415541'},
        {label: 'Xây dựng', value: 22,email : 'xaydung@gmail.com', phoneNumber : '0974456123'},
        {label: 'Khác', value: -1,email : 'other@gmail.com', phoneNumber : '0985456123'},
      ]
    }
  },
  methods: {
    manageTopic() {
      let id = this.params.data.value
      this.$router.push(`/admin/manage-topic-trial?id=${id}`).catch(() => {
      });
    },
    createTopicTrial() {
      let id = this.params.data.value
      this.$router.push(`/admin/trial-create-topic?id=${id}`).catch(() => {
      });
    },

  }
}
</script>
